import DOMPurify from 'dompurify';

/**
 * Säubert vom Backend gelieferte HTML-Inhalte (E-Mail-Bodies, DSGVO-Texte etc.),
 * bevor sie via `dangerouslySetInnerHTML` gerendert werden. Entfernt
 * scriptbasierte Vektoren (`<script>`, `on*`-Attribute, `javascript:`-URLs)
 * und alles, was mit Frame-Targeting Schaden anrichten könnte.
 */
export const sanitizeHtml = (raw: string | null | undefined): string => {
  if (!raw) return '';
  return DOMPurify.sanitize(raw, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['style'],
  });
};
